<template>
  <a-card :style="cardStyle" :bordered="false">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <div class="tabs-header">
          <a-tabs :active-key="activeKey" @change="handleTabChange">
            <a-tab-pane key="sec1" tab="基本资料" />
            <a-tab-pane key="sec2" tab="配置信息" />
            <a-tab-pane key="sec3" tab="总店性质" />
            <a-tab-pane key="sec4" tab="地址定位与地图服务" />
          </a-tabs>
          <a-button class="tabs-save-btn" type="primary" :loading="confirmLoading" @click="handleSaveAll">保存</a-button>
        </div>
        <div class="content-container" :style="contentStyle" ref="container">
          <div id="sec1" class="section" ref="sec1">
            <h2>基本资料</h2>
            <a-row class="form-row" :gutter="24">
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="公司名称">
                  <a-input placeholder="请输入公司名称" v-decorator.trim="[ 'companyName' ]" :disabled="hqManaged" @change="handleCompanyName" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="联系人">
                  <a-input placeholder="请输入联系人" v-decorator.trim="[ 'companyContacts' ]" :disabled="hqManaged" @change="handleCompanyContacts" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="公司电话">
                  <a-input placeholder="请输入公司电话" v-decorator.trim="[ 'companyTel' ]" :disabled="hqManaged" @change="handleCompanyTel" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="公司传真">
                  <a-input placeholder="请输入公司传真" v-decorator.trim="[ 'companyFax' ]" :disabled="hqManaged" @change="handleCompanyFax" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="公司邮编">
                  <a-input placeholder="请输入公司邮编" v-decorator.trim="[ 'companyPostCode' ]" :disabled="hqManaged" @change="handleCompanyPostCode" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="baseWrapperCol" label="销售协议">
                  <a-input placeholder="请输入销售协议" v-decorator.trim="[ 'saleAgreement' ]" @change="handleSaleAgreement" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <div id="sec2" class="section" ref="sec2">
            <h2>配置信息</h2>
            <a-row class="form-row" :gutter="24">
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分配仓库权限">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="depotFlagSwitch" @change="onDepotChange"></a-switch>
                  （启用后，需要到<b>用户管理</b>进行<b>分配仓库</b>，针对专人管理仓库的场景）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分配客户权限">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="customerFlagSwitch" @change="onCustomerChange"></a-switch>
                  （启用后，需要到<b>用户管理</b>进行<b>分配客户</b>，针对销售员只能看自己客户的场景）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支持负库存">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="minusStockFlagSwitch" @change="onMinusStockChange"></a-switch>
                  （启用后，单据<b>支持负库存</b>录入，不会再提示库存不足）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="以销定购">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="purchaseBySaleFlagSwitch" @change="onPurchaseBySaleChange"></a-switch>
                  （启用后，根据<b>销售订单</b>来定制<b>采购订单</b>，进货后再发给客户）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="超出关联单据">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="overLinkBillFlagSwitch" @change="onOverLinkBillChange"></a-switch>
                  （启用后，允许当前单据<b>超出关联单据</b>的商品数量进行出入库）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="更新单价">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="updateUnitPriceFlagSwitch" @change="onUpdateUnitPriceChange"></a-switch>
                  （启用后，会根据单据录入自动更新商品单价，默认是启用状态）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="强审核">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="forceApprovalFlagSwitch" @change="onForceApprovalChange"></a-switch>
                  （启用后，只有<b>已审核</b>的单据才能产生库存，涉及库存查询的相关报表。启用或关闭后需到<b>商品管理</b>批量<b>修正库存</b>，请按实际业务谨慎操作）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出入库管理">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="inOutManageFlagSwitch" @change="onInOutManageChange"></a-switch>
                  （启用后，采购销售相关单据都需经过<b>其它出入库</b>单据，才能产生库存。启用或关闭后需到<b>商品管理</b>批量<b>修正库存</b>，请按实际业务谨慎操作）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="多账户">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="multiAccountFlagSwitch" @change="onMultiAccountChange"></a-switch>
                  （启用后，采购订单、采购入库、采购退货、销售订单、销售出库、销售退货等单据的结算账户可以进行多账户选择）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="移动平均价">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="moveAvgPriceFlagSwitch" @change="onMoveAvgPriceChange"></a-switch>
                  （默认为关闭状态，代表成本价等于商品信息页面录入的采购价。开启之后将通过移动平均来计算成本价，需到<b>商品管理</b>批量<b>修正成本</b>，请按实际业务谨慎操作）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="先审核后打印">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="auditPrintFlagSwitch" @change="onAuditPrintChange"></a-switch>
                  （启用后，零售管理、采购管理、销售管理和仓库管理下的单据，都需要先审核之后才能进行打印）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="零收付款">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="zeroChangeAmountFlagSwitch" @change="onZeroChangeAmountChange"></a-switch>
                  （启用后，销售出库单据新建时默认<b>本次收款</b>为0，采购入库单据同理）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户静态单价">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="customerStaticPriceFlagSwitch" @change="onCustomerStaticPriceChange"></a-switch>
                  （启用后，客户的销售出库的单价不会从该客户历史单据的单价获取，而是只从商品信息获取）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品价格含税">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="materialPriceTaxFlagSwitch" @change="onMaterialPriceTaxChange"></a-switch>
                  （启用后，商品中录入的价格变成含税价格，在单据录入中包含了税额）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自动打印">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="autoPrintFlagSwitch" @change="onAutoPrintChange"></a-switch>
                  （开启后所有单据均自动打印，不能进行报表设计，若要进行报表设计，请在这里关闭）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自动凭证">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="autoVoucherFlagSwitch" @change="onAutoVoucherChange"></a-switch>
                  （开启后业务单据审核通过即自动生成会计凭证；关闭后由财务手工录入/审核）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="启用系统商品分类">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="enableCategoryFlagSwitch" @change="onEnableCategoryChange"></a-switch>
                  （启用后，小程序扫码增加商品时自动使用全局商品的系统分类（取前两级），租户没有该分类会自动创建）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商城显示商品图片">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="shopImgFlagSwitch" @change="onShopImgChange"></a-switch>
                  （开启后商城（小程序/PC）商品列表显示缩略图，商品无图时显示占位图；关闭后不显示图片）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="会员商城自动上架">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="memberAutoShelfFlagSwitch" @change="onMemberAutoShelfChange"></a-switch>
                  （开启后从未配置过的商品有库存即自动上架到会员商城；手动上架/下架的商品仍以手动配置为准，手动下架的商品有库存也不显示）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24" v-if="isShowApproval">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="多级审核">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="multiLevelApprovalFlagSwitch" @change="onMultiLevelApprovalChange"></a-switch>
                  <a-select placeholder="请选择流程类型" v-model="multiBillTypeSelect" style="width:400px;padding-left:10px"
                            mode="multiple" :maxTagCount="6" :dropdownMatchSelectWidth="false"
                            showSearch allow-clear optionFilterProp="children" @change="onMultiBillTypeChange">
                    <a-select-option v-for="(item,index) in billTypeList" :key="index" :value="item.key">
                      {{ item.value }}
                    </a-select-option>
                  </a-select>
                  （启用后，多级审核需配置流程，开启后需刷新浏览器才能看到效果）<a-button type="link" @click="handleReload">点此刷新</a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <div id="sec3" class="section" ref="sec3">
            <h2>总店性质</h2>
            <a-row class="form-row" :gutter="24">
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总店性质">
                  <a-switch checked-children="启用" un-checked-children="关闭" v-model="isHeadquartersSwitch" @change="onHeadquartersChange"></a-switch>
                  （开启后本租户可作为总店添加门店）
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24" v-if="isHeadquartersSwitch">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="允许查询门店的数据项">
                  <a-checkbox-group v-model="allowQueryItemsChecked" @change="onAllowQueryItemsChange" style="padding-left:10px">
                    <a-checkbox v-for="item in queryItemDomainList" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-checkbox>
                  </a-checkbox-group>
                  （开启的数据项，总店在报表页可选择门店查询该店数据；未开启不能查）
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <!-- 地址定位与地图服务（decentralize-store-pay C：地理信息唯一存储=system_config；
                主体资料编辑区随 tenant_profile 退役移除，进件资料唯一维护处=商户进件向导） -->
          <div id="sec4" class="section" ref="sec4">
            <h2>地址定位与地图服务</h2>
            <div v-if="hqManaged" class="hq-managed-tip">
              该门店未开启收款，公司信息与地图配置由总店统一维护（当前为只读）
            </div>
            <a-row class="form-row" :gutter="24">
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="腾讯地图Key">
                  <a-input v-model="geoForm.tencentMapKey" placeholder="腾讯位置服务 Key" style="width:400px" :disabled="hqManaged" />
                  <div class="profile-tip">需在腾讯位置服务控制台创建 Key 并勾选"JavaScript API"与"Web服务API"两类产品；费用由商户自己承担</div>
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在区域">
                  <a-cascader
                    v-model="geoAreaPath"
                    :options="areaOptions"
                    placeholder="请选择省/市/区"
                    style="width:400px"
                    :disabled="hqManaged"
                    change-on-select
                    @change="onGeoAreaChange" />
                  <div class="profile-tip">公司注册地址即门店经营地址（一租户一营业执照）；区域与定位供进件预填、外卖配送距离、小程序门店地图使用</div>
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="{ xs: 24, sm: 20 }" label="公司地址">
                  <span class="addr-search-row">
                    <a-input
                      placeholder="请输入详细地址（无需填写省市区），点搜索定位"
                      v-decorator.trim="[ 'companyAddress' ]"
                      :disabled="hqManaged"
                      style="width:400px"
                      @change="handleCompanyAddress"
                      @pressEnter="onGeoAddressSearch" />
                    <a-button type="primary" icon="search" class="addr-search-btn" :disabled="hqManaged" @click="onGeoAddressSearch">搜索</a-button>
                  </span>
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="{ xs: 24, sm: 20 }" label="地图定位">
                  <map-location-panel ref="geoPanel" :lat="geoForm.lat" :lng="geoForm.lng" :address="model.companyAddress" :disabled="hqManaged" @change="onGeoMapChange" />
                  <div class="profile-tip">地图选点/搜索后详细地址自动回填上方公司地址；改动后点页面右上角「保存」统一生效</div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-form>
    </a-spin>
  </a-card>
</template>
<!-- b y 7 5 2 7  1 8 9 2 0 -->
<script>
  import pick from 'lodash.pick'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  import { addSystemConfig, editSystemConfig } from '@/api/api'
  import { getAction, putAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin.js'
  import { pcaa } from 'area-data'
  import MapLocationPanel from '@/views/plugin/dining/store/MapLocationPanel'

  // 省市区三级联动选项（area-data pcaa，构建方式照 dining StoreInfo AREA_OPTIONS）
  const AREA_OPTIONS = (() => {
    const provinces = pcaa['86'] || {}
    const tree = []
    Object.keys(provinces).forEach(pCode => {
      const pNode = { value: pCode, label: provinces[pCode], children: [] }
      const cities = pcaa[pCode] || {}
      Object.keys(cities).forEach(cCode => {
        const cNode = { value: cCode, label: cities[cCode], children: [] }
        const districts = pcaa[cCode] || {}
        Object.keys(districts).forEach(dCode => {
          cNode.children.push({ value: dCode, label: districts[dCode] })
        })
        pNode.children.push(cNode)
      })
      tree.push(pNode)
    })
    return tree
  })()

  export default {
    name: "SystemConfigList",
    mixins: [mixinDevice],
    components: {
      JSelectMultiple,
      MapLocationPanel
    },
    data () {
      return {
        title:"操作",
        cardStyle: '',
        contentStyle: '',
        activeKey: 'sec1',
        visible: true,
        model: {},
        depotFlagSwitch: false, //仓库权限状态
        customerFlagSwitch: false, //客户权限状态
        minusStockFlagSwitch: false, //负库存状态
        purchaseBySaleFlagSwitch: false, //以销定购状态
        overLinkBillFlagSwitch: false, //超出关联单据状态
        updateUnitPriceFlagSwitch: true, //更新单价状态
        forceApprovalFlagSwitch: false, //强审核
        inOutManageFlagSwitch: false, //出入库管理
        multiLevelApprovalFlagSwitch: false, //多级审核
        originalMultiLevelApprovalFlag: '0', //原始多级审核状态
        multiBillTypeSelect: [], //单据类型
        originalMultiBillTypeSelect: [], //原始单据类型
        isShowApproval: false, //是否展示多级审核
        multiAccountFlagSwitch: false, //多账户
        moveAvgPriceFlagSwitch: false, //移动平均价
        auditPrintFlagSwitch: false, //先审核后打印
        zeroChangeAmountFlagSwitch: false, //零收付款
        customerStaticPriceFlagSwitch: false, //客户静态单价
        materialPriceTaxFlagSwitch: false, //商品价格含税
        autoPrintFlagSwitch: false, //自动打印
        autoVoucherFlagSwitch: false, //自动凭证
        enableCategoryFlagSwitch: false, //启用系统商品分类
        shopImgFlagSwitch: false, //商城显示商品图片
        memberAutoShelfFlagSwitch: false, //会员商城有库存自动上架
        isHeadquartersSwitch: false, //总店性质
        allowQueryItemsChecked: [], //允许查询门店的数据项（域编码数组）
        // ===== 地址定位与地图服务（decentralize-store-pay C：地理信息唯一存储=system_config） =====
        geoForm: {
          tencentMapKey: '', provinceId: null, cityId: null, zoneId: null, lat: null, lng: null
        },
        geoAreaPath: [],
        geoSaving: false,
        // 腾讯地图Key 脱敏回显串（保存时未变化则不提交 Key，防脱敏串污染真实值）
        geoKeyMasked: '',
        // 关收款门店信息由总店统一维护（store-context：isStore && allowPay!='1' && !proxied）→ 只读
        hqManaged: false,
        // 省市区三级联动选项（pcaa 字符串码）
        areaOptions: AREA_OPTIONS,
        queryItemDomainList: [ //允许查询门店的数据项域选项（后续插件复用同编码）
          { 'value': 'stock', 'label': '进销存与库存' },
          { 'value': 'sale', 'label': '销售与利润' },
          { 'value': 'capital', 'label': '资金与往来' },
          { 'value': 'finance', 'label': '财务报表（利润表/资产负债表/现金流量表/试算平衡表等）' },
          { 'value': 'dining', 'label': '餐饮订单' }
        ],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 2 },
        },
        baseWrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        billTypeList: [
          { 'key': 'LSCK', 'value': '零售出库' },
          { 'key': 'LSTH', 'value': '零售退货' },
          { 'key': 'QGD', 'value': '请购单' },
          { 'key': 'CGDD', 'value': '采购订单' },
          { 'key': 'CGRK', 'value': '采购入库' },
          { 'key': 'CGTH', 'value': '采购退货' },
          { 'key': 'XSDD', 'value': '销售订单' },
          { 'key': 'XSCK', 'value': '销售出库' },
          { 'key': 'XSTH', 'value': '销售退货' },
          { 'key': 'QTRK', 'value': '其它入库单' },
          { 'key': 'QTCK', 'value': '其它出库单' },
          { 'key': 'DBCK', 'value': '调拨出库' },
          { 'key': 'ZZD', 'value': '组装单' },
          { 'key': 'CXD', 'value': '拆卸单' },
          { 'key': 'SR', 'value': '收入单' },
          { 'key': 'ZC', 'value': '支出单' },
          { 'key': 'SK', 'value': '收款单' },
          { 'key': 'FK', 'value': '付款单' },
          { 'key': 'ZZ', 'value': '转账单' },
          { 'key': 'SYF', 'value': '收预付款单' },
          { 'key': 'ZG', 'value': '资产转固单' },
          { 'key': 'ZCBD', 'value': '资产变动单' },
          { 'key': 'ZCWX', 'value': '资产维修单' },
          { 'key': 'ZCDB', 'value': '资产调拨单' },
          { 'key': 'ZCJT', 'value': '折旧计提单' },
          { 'key': 'ZCCZ', 'value': '资产处置单' },
          { 'key': 'ZCBF', 'value': '资产报废单' },
          { 'key': 'FTDD', 'value': '发图订单' },
        ]
      }
    },
    computed: {
      // 省市区文本（cascader 选中路径在选项树反查 label 拼接，作地址搜索关键词前缀）
      geoAreaText() {
        if (!this.geoAreaPath || !this.geoAreaPath.length) {
          return ''
        }
        let nodes = this.areaOptions
        const labels = []
        this.geoAreaPath.forEach(code => {
          const hit = (nodes || []).find(n => n.value === code)
          if (!hit) {
            return
          }
          labels.push(hit.label)
          nodes = hit.children
        })
        return labels.join('')
      }
    },
    created () {
      this.init()
      this.loadPlugins()
      this.loadGeoConfig()
      this.initStoreContext()
      if(this.isDesktop()) {
        this.cardStyle = 'height:' + (document.documentElement.clientHeight-100) + 'px'
        this.contentStyle = 'height:' + (document.documentElement.clientHeight-220) + 'px'
      }
    },
    methods: {
      handleTabChange(key) {
        this.activeKey = key
        // 使用 setTimeout 确保 DOM 更新完成
        this.$nextTick(() => {
          const element = document.getElementById(key)
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',  // 平滑滚动
              block: 'start'       // 滚动到顶部
            })
          }
        })
      },
      //初始化加载内容
      init () {
        let param = {
          search: {"companyName":""},
          currentPage: 1,
          pageSize: 10
        }
        getAction('/systemConfig/list', param).then((res)=>{
          if(res.code === 200){
            let record = res.data.rows[0]
            this.form.resetFields();
            this.model = Object.assign({}, record);
            // 允许门店收款已升级为门店级开关（jsh_store.allow_pay，连锁结算页逐店配置），
            // 全局开关失效：提交剔除该字段，主工程表列保留不再读写
            delete this.model.allowStorePay;
            this.visible = true;
            this.$nextTick(() => {
              this.form.setFieldsValue(pick(this.model,'companyName', 'companyContacts', 'companyAddress',
                'companyTel', 'companyFax', 'companyPostCode', 'saleAgreement'))
            });
            if(record.id) {
              if (record.depotFlag != null) {
                this.depotFlagSwitch = record.depotFlag == '1' ? true : false;
              }
              if (record.customerFlag != null) {
                this.customerFlagSwitch = record.customerFlag == '1' ? true : false;
              }
              if (record.minusStockFlag != null) {
                this.minusStockFlagSwitch = record.minusStockFlag == '1' ? true : false;
              }
              if (record.purchaseBySaleFlag != null) {
                this.purchaseBySaleFlagSwitch = record.purchaseBySaleFlag == '1' ? true : false;
              }
              if (record.overLinkBillFlag != null) {
                this.overLinkBillFlagSwitch = record.overLinkBillFlag == '1' ? true : false;
              }
              if (record.updateUnitPriceFlag != null) {
                this.updateUnitPriceFlagSwitch = record.updateUnitPriceFlag == '1' ? true : false;
              }
              if (record.forceApprovalFlag != null) {
                this.forceApprovalFlagSwitch = record.forceApprovalFlag == '1' ? true : false;
              }
              if (record.inOutManageFlag != null) {
                this.inOutManageFlagSwitch = record.inOutManageFlag == '1' ? true : false;
              }
              if (record.multiLevelApprovalFlag != null) {
                this.multiLevelApprovalFlagSwitch = record.multiLevelApprovalFlag == '1' ? true : false;
                this.originalMultiLevelApprovalFlag = record.multiLevelApprovalFlag
              }
              if (record.multiBillType != null && record.multiBillType != '') {
                this.multiBillTypeSelect = record.multiBillType.split(',')
                this.originalMultiBillTypeSelect = record.multiBillType
              }
              if (record.multiAccountFlag != null) {
                this.multiAccountFlagSwitch = record.multiAccountFlag == '1' ? true : false;
              }
              if (record.moveAvgPriceFlag != null) {
                this.moveAvgPriceFlagSwitch = record.moveAvgPriceFlag == '1' ? true : false;
              }
              if (record.auditPrintFlag != null) {
                this.auditPrintFlagSwitch = record.auditPrintFlag == '1' ? true : false;
              }
              if (record.zeroChangeAmountFlag != null) {
                this.zeroChangeAmountFlagSwitch = record.zeroChangeAmountFlag == '1' ? true : false;
              }
              if (record.customerStaticPriceFlag != null) {
                this.customerStaticPriceFlagSwitch = record.customerStaticPriceFlag == '1' ? true : false;
              }
              if (record.materialPriceTaxFlag != null) {
                this.materialPriceTaxFlagSwitch = record.materialPriceTaxFlag == '1' ? true : false;
              }
              if (record.autoPrint != null) {
                this.autoPrintFlagSwitch = record.autoPrint == '1' ? true : false;
              }
              if (record.autoVoucherFlag != null) {
                this.autoVoucherFlagSwitch = record.autoVoucherFlag == '1' ? true : false;
              }
              if (record.enableCategory != null) {
                this.enableCategoryFlagSwitch = record.enableCategory == '1' ? true : false;
              }
              if (record.shopImg != null) {
                this.shopImgFlagSwitch = record.shopImg == '1' ? true : false;
              }
              if (record.memberAutoShelf != null) {
                this.memberAutoShelfFlagSwitch = record.memberAutoShelf == '1' ? true : false;
              }
              if (record.isHeadquarters != null) {
                this.isHeadquartersSwitch = record.isHeadquarters == '1' ? true : false;
              }
              this.allowQueryItemsChecked = this.parseQueryItems(record.allowQueryItems)
            }
          } else {
            this.$message.info(res.data);
          }
        })
      },
      loadPlugins() {
        //校验是否存在多级审批插件
        getAction('/plugin/checkByPluginId', { pluginIds: 'workflow' }).then((res)=> {
          if (res.code === 200) {
            if(res.data) {
              this.isShowApproval = true
              this.billTypeList.push({ 'key': 'NSLD', 'value': '资产申领' }, { 'key': 'NCKD', 'value': '资产出库' })
            }
          }
        })
        //校验是否存在盘点插件
        getAction('/plugin/checkByPluginId', { pluginIds: 'stock-check' }).then((res)=> {
          if (res.code === 200) {
            if(res.data) {
              this.billTypeList.push({ 'key': 'PDLR', 'value': '盘点录入' }, { 'key': 'PDFP', 'value': '盘点复盘' })
              //校验是否存在生产插件
              getAction('/plugin/checkByPluginId', { pluginIds: 'produce' }).then((res)=> {
                if (res.code === 200) {
                  if(res.data) {
                    this.billTypeList.push({ 'key': 'SC', 'value': '生产任务' }, { 'key': 'WW', 'value': '委外任务' })
                  }
                }
              })
            }
          }
        })
      },
      handleCompanyName(event) {
        this.model.companyName = event.target.value
        if(this.model.companyName && this.model.companyName.length>30) {
          this.$message.warning('公司名称长度超过30个字符')
        }
      },
      handleCompanyContacts(event) {
        this.model.companyContacts = event.target.value
      },
      handleCompanyAddress(event) {
        this.model.companyAddress = event.target.value
      },
      handleCompanyTel(event) {
        this.model.companyTel = event.target.value
      },
      handleCompanyFax(event) {
        this.model.companyFax = event.target.value
      },
      handleCompanyPostCode(event) {
        this.model.companyPostCode = event.target.value
      },
      handleSaleAgreement(event) {
        this.model.saleAgreement = event.target.value
        if(this.model.saleAgreement && this.model.saleAgreement.length>400) {
          this.$message.warning('销售协议长度超过400个字符')
        }
      },
      onDepotChange(checked) {
        this.model.depotFlag = checked?'1':'0'
      },
      onCustomerChange(checked) {
        this.model.customerFlag = checked?'1':'0'
      },
      onMinusStockChange(checked) {
        this.model.minusStockFlag = checked?'1':'0'
      },
      onPurchaseBySaleChange(checked) {
        this.model.purchaseBySaleFlag = checked?'1':'0'
      },
      onOverLinkBillChange(checked) {
        this.model.overLinkBillFlag = checked?'1':'0'
      },
      onUpdateUnitPriceChange(checked) {
        this.model.updateUnitPriceFlag = checked?'1':'0'
      },
      onForceApprovalChange(checked) {
        this.model.forceApprovalFlag = checked?'1':'0'
      },
      onInOutManageChange(checked) {
        this.model.inOutManageFlag = checked?'1':'0'
      },
      onMultiLevelApprovalChange(checked) {
        this.model.multiLevelApprovalFlag = checked?'1':'0'
        if(!checked) {
          this.multiBillTypeSelect = []
          this.model.multiBillType = ''
        }
      },
      onMultiBillTypeChange() {
        this.model.multiBillType = this.multiBillTypeSelect.join(",")
      },
      onMultiAccountChange(checked) {
        this.model.multiAccountFlag = checked?'1':'0'
      },
      onMoveAvgPriceChange(checked) {
        this.model.moveAvgPriceFlag = checked?'1':'0'
      },
      onAuditPrintChange(checked) {
        this.model.auditPrintFlag = checked?'1':'0'
      },
      onZeroChangeAmountChange(checked) {
        this.model.zeroChangeAmountFlag = checked?'1':'0'
      },
      onCustomerStaticPriceChange(checked) {
        this.model.customerStaticPriceFlag = checked?'1':'0'
      },
      onMaterialPriceTaxChange(checked) {
        this.model.materialPriceTaxFlag = checked?'1':'0'
      },
      onAutoPrintChange(checked) {
        this.model.autoPrint = checked ? '1' : '0'
      },
      onAutoVoucherChange(checked) {
        this.model.autoVoucherFlag = checked ? '1' : '0'
      },
      onEnableCategoryChange(checked) {
        this.model.enableCategory = checked ? '1' : '0'
      },
      onShopImgChange(checked) {
        this.model.shopImg = checked ? '1' : '0'
      },
      onMemberAutoShelfChange(checked) {
        this.model.memberAutoShelf = checked ? '1' : '0'
      },
      //解析允许查询门店的数据项配置（null/空/异常返回空数组=全关）
      parseQueryItems(value) {
        if (value == null || value === '') {
          return []
        }
        try {
          let arr = JSON.parse(value)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      },
      onHeadquartersChange(checked) {
        this.model.isHeadquarters = checked ? '1' : '0'
      },
      onAllowQueryItemsChange(checkedValues) {
        this.model.allowQueryItems = JSON.stringify(checkedValues)
      },
      // ===== 地址定位与地图服务（decentralize-store-pay C/D：GET/PUT /api/plugin/dining/map/config） =====
      // 维护权分层：关收款门店（isStore && allowPay!='1' && !proxied）→ 公司信息与地图配置只读
      initStoreContext() {
        getAction('/api/plugin/dining/store-context').then((res) => {
          if (res.code === 200 && res.data) {
            const d = res.data
            this.hqManaged = !!d.isStore && String(d.allowPay) !== '1' && !d.proxied
          }
        }).catch(() => { /* 插件未安装时保持可编辑（独立租户场景） */ })
      },
      loadGeoConfig() {
        getAction('/api/plugin/dining/map/config').then((res) => {
          if (res.code === 200 && res.data) {
            const d = res.data
            this.geoKeyMasked = this.maskKey(d.tencentMapKey)
            this.geoForm = {
              tencentMapKey: this.geoKeyMasked,
              provinceId: d.provinceId || null,
              cityId: d.cityId || null,
              zoneId: d.zoneId || null,
              lat: d.lat || null,
              lng: d.lng || null
            }
            this.resolveGeoAreaPath()
          }
        }).catch(() => { /* 插件未安装或查询失败时保持默认值 */ })
      },
      // 腾讯地图Key 脱敏（中间 * 替换，仅保留首尾特征）
      maskKey(key) {
        const k = key || ''
        if (!k) {
          return ''
        }
        return k.length <= 10 ? '******' : k.slice(0, 6) + '******' + k.slice(-4)
      },
      // 省市区码 → cascader 路径（pcaa 字符串码，数字码匹配失败显示为空）
      resolveGeoAreaPath() {
        this.geoAreaPath = [this.geoForm.provinceId, this.geoForm.cityId, this.geoForm.zoneId].filter(v => v).map(String)
      },
      onGeoAreaChange(value) {
        this.geoForm.provinceId = value && value[0] ? Number(value[0]) : null
        this.geoForm.cityId = value && value[1] ? Number(value[1]) : null
        this.geoForm.zoneId = value && value[2] ? Number(value[2]) : null
      },
      // 地址搜索：省市区前缀+详细地址拼关键词 → 面板定位回填经纬度（云贝同款交互）
      onGeoAddressSearch() {
        const addr = (this.model.companyAddress || '').trim()
        if (!addr) {
          this.$message.warning('请输入详细地址后再搜索')
          return
        }
        if (this.$refs.geoPanel) {
          this.$refs.geoPanel.doSearch(this.geoAreaText + addr, addr)
        }
      },
      // 地图选点/搜索回填：经纬度入 geoForm，逆解析地址回填「基本资料」公司地址（待用户核对保存）
      onGeoMapChange(payload) {
        if (!payload) {
          return
        }
        this.geoForm.lat = payload.lat
        this.geoForm.lng = payload.lng
        if (payload.address) {
          this.model.companyAddress = payload.address
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model, 'companyAddress'))
          })
        }
      },
      saveGeoConfig(silent) {
        const f = this.geoForm
        const body = {
          companyAddress: this.model.companyAddress,
          provinceId: f.provinceId, cityId: f.cityId, zoneId: f.zoneId,
          lat: f.lat, lng: f.lng
        }
        // Key 未改动（仍为脱敏串）不提交，防 * 污染真实值；改动/清空才提交
        if (f.tencentMapKey !== this.geoKeyMasked) {
          body.tencentMapKey = f.tencentMapKey
        }
        this.geoSaving = true
        putAction('/api/plugin/dining/map/config', body).then((res) => {
          if (res.code === 200) {
            if (!silent) {
              this.$message.success('地图配置保存成功')
            }
          } else {
            this.$message.warning(res.message || '地图配置保存失败')
          }
        }).catch(() => {
          this.$message.warning('地图配置保存失败')
        }).finally(() => {
          this.geoSaving = false
        })
      },
      // ===== 整页统一保存（原"改动即存"废除：一次提交主表单 + 地图配置） =====
      handleSaveAll() {
        this.confirmLoading = true
        const obj = !this.model.id ? addSystemConfig(this.model) : editSystemConfig(this.model)
        obj.then((res) => {
          if (res.code === 200) {
            this.init()
            this.$message.success('保存成功')
            // 地址定位与地图服务一并保存；关收款门店由总店维护不提交（表单已禁用）
            if (!this.hqManaged) {
              this.saveGeoConfig(true)
            }
          } else {
            this.$message.warning(res.data && res.data.message ? res.data.message : '保存失败')
          }
        }).finally(() => {
          this.confirmLoading = false
        })
      },
      //刷新浏览器
      handleReload() {
        location.reload()
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>
<style>
.ant-form-item {
  margin-bottom: 12px;
}
.profile-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}
/* 关收款门店信息由总店统一维护提示（decentralize-store-pay D） */
.hq-managed-tip {
  color: #fa8c16;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 8px;
}
/* 公司地址输入+搜索按钮同行排布 */
.addr-search-row {
  display: inline-flex;
  align-items: center;
}
.addr-search-btn {
  margin-left: 8px;
}
.tabs-header {
  flex-shrink: 0;  /* 防止被压缩 */
  background: white;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
}
.tabs-header .ant-tabs {
  flex: 1;
  min-width: 0;
}
.tabs-save-btn {
  margin-right: 16px;
  flex-shrink: 0;
  padding: 0 8px;
}
/* 固定高度的滚动容器 */
.content-container {
  overflow-y: auto;   /* 出现滚动条 */
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}

/* 每个区域样式 */
.section {
  margin-bottom: 24px;
  padding: 10px 10px 10px 20px;
  background-color: #fafafa;
  border-radius: 4px;
  min-height: 200px;
  font-size: 12px;
}

.section h2 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #1890ff;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 8px;
}

/* 可选的滚动条美化 */
.content-container::-webkit-scrollbar {
  width: 6px;
}

.content-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.content-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
</style>